var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'domain-new',
  created () {
  },
  data () {
    return {
      canValidate: true,
      savingFlag: false,
      domain: {
        domain_name: null,
        domain_content: null
      }
    }
  },
  computed: {
    validation: function () {
      var v = {
        domain_name: !!this.domain.domain_name,
        domain_content: !!this.domain.domain_content,
        not_input: !!this.domain.domain_name && !!this.domain.domain_content
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true; });
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    }
  },
  components: {
    AppHeader
  },
  methods: {
    onClickSave: function () {
      if (this.savingFlag) return false
      this.canValidate = true
      if (this.isValid) {
        this.savingFlag = true
        console.log("is valid")
        this.$store.dispatch('DOMAIN_CREATE',
          { data: this.domain, callback: this.onSaved })
      }else{
        console.log("need edit")
      }
    },
    onClickCancel: function () {
      this.$router.push({ path: '/domains', query: { type: this.$router.currentRoute.query.type}})
    },
    onSaved: function (result) {
      this.savingFlag = false
      this.$router.push('/domains')
    },
    halfName: function () {
      this.domain.domain_name = utils.emHalf(this.domain.domain_name)
    },
    halfContent: function () {
      this.domain.domain_content = utils.emHalf(this.domain.domain_content)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/domain-new.js